import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

export type Config = {
  url: string;
  mobisub: {
    apiKey: string;
    url: string;
    mobisubUrl: string;
    production: boolean;
  };
  auth: {
    url: string;
    apikey: string;
  };
};

export interface IAppConfig {
  baseWsURL: string;
  apiKey: string;
  authUrl: string;
  authApikey: string;
  load: () => Observable<Config>;
}

@Injectable()
export class AppConfig implements IAppConfig {
  private readonly http = inject(HttpClient);

  public apiKey = '';
  public baseWsURL = '';
  public authUrl = '';
  public authApikey = '';
  public mobiSubUrl = '';
  public mobiSubBackUrl = '';

  public load(): Observable<Config> {
    return this.http.get<Config>('./assets/config.json').pipe(
      tap({
        next: (config: Config) => {
          this.apiKey = config?.mobisub.apiKey ?? '';
          this.baseWsURL = config?.url ?? '';
          this.authUrl = config?.auth?.url ?? '';
          this.authApikey = config?.auth?.apikey ?? '';
          this.mobiSubUrl = config.mobisub.mobisubUrl;
          this.mobiSubBackUrl = config.mobisub.url;
        },
        error: (err: HttpErrorResponse) => {
          console.log(err.message);
        }
      })
    );
  }
}

export const initConfig =
  (config: AppConfig): (() => Observable<Config>) =>
  () =>
    config.load();
